import { Component, ViewChild } from '@angular/core';
import { QuillEditorComponent } from 'ngx-quill';
import { BreadcrumbService } from '../../../../breadcrumb.service';
import { RouterConst } from '../../../../globals/RoutersConst';
import { SuperClass } from '../../../../superclass/SuperClass';
import { DashboardDataService } from '../../../../services/dashboard-data.service';
import { ClientsService } from '../../../../services/clients/clients.service';
import { WsService } from '../../../../services/websocket/WsService';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { MessagingStrategy } from './messaging-strategy.model';
import { MessagingRule } from './messaging-rule.model';
import { isNull, isNullOrUndefined, isUndefined } from 'util';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Calendar } from 'primeng/primeng';

@Component({
  selector: 'app-messaging-strategies',
  templateUrl: './messaging-strategies.component.html',
  styleUrls: ['./messaging-strategies.component.css'],
})
export class MessagingStrategiesComponent extends SuperClass {
  deviceTypes;
  periodsOfDay;
  periodsOfDayStart;
  periodsOfDayEnd;
  daysOfWeek;

  newStrategy;
  newRule;
  selectedStrategy: MessagingStrategy;
  selectedRule: MessagingRule;

  newRuleForm: FormGroup;
  selectedRuleForm: FormGroup;
  newStrategyForm: FormGroup;
  selectedStrategyForm: FormGroup;

  messagingStrategies;
  messagingRules;
  outputHTML;

  displayStrategy = false;
  displayRule = false;
  @ViewChild('editor') editor: QuillEditorComponent;
  @ViewChild('calendar') calendar: Calendar;
  PERIOD_START_ANY = -1;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private fb: FormBuilder,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );
    this.breadcrumbService.setItems([
      { label: 'Organization' },
      { label: 'Captive Portal' },
      {
        label: 'Messaging Strategies',
        routerLink: [{ outlets: { sub: [RouterConst.MESSAGING_STRATEGIES] } }],
      },
    ]);
    this.newStrategy = new MessagingStrategy();
    this.newRule = new MessagingRule();
  }

  reloadData() {
    this.http_getMessagingStrategies((data: any) => {
      this.messagingStrategies = data.payload;
    });

    this.http_getMessagingStrategyPeriodOfDay((data: any) => {
      this.periodsOfDay = data.payload;
      this.periodsOfDayEnd = data.payload;
      this.periodsOfDayStart = data.payload.filter(function(el) {
        return el.id !== 24;
      });
    });

    this.http_getMessagingStrategyDayOfWeek((data: any) => {
      this.daysOfWeek = data.payload;
    });

    this.http_getMessagingStrategyDeviceType((data: any) => {
      this.deviceTypes = data.payload;
    });

    this.selectedRuleForm = this.fb.group({
      dayOfWeek: new FormControl('', Validators.required),
      periodStart: new FormControl('', Validators.required),
      periodEnd: new FormControl('', Validators.required),
      deviceType: new FormControl('', Validators.required),
      numberOfLogin: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(2147483647),
        ]),
      ),
      date: new FormControl('', Validators.required),
    });

    this.newRuleForm = this.fb.group({
      dayOfWeek: new FormControl('', Validators.required),
      periodStart: new FormControl('', Validators.required),
      periodEnd: new FormControl('', Validators.required),
      deviceType: new FormControl('', Validators.required),
      numberOfLogin: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(2147483647),
        ]),
      ),
      date: new FormControl('', Validators.required),
    });

    this.newStrategyForm = this.fb.group({
      name: new FormControl('', Validators.required),
    });

    this.selectedStrategyForm = this.fb.group({
      name: new FormControl('', Validators.required),
    });

    this.newRuleForm.controls['date'].disable();
  }

  selectStrategyRow(e) {
    this.selectedStrategy = new MessagingStrategy(e.data);
    this.http_getMessagingStrategyRules(
      this.selectedStrategy.id,
      (data: any) => {
        console.log('Rules', data);
        this.loadRulesFromResponse(data);
      },
    );
  }

  selectRuleRow(e) {
    this.selectedRule = new MessagingRule(e.data);
    if (this.selectedRule.useExactDate === true) {
      this.selectedRuleForm.controls['dayOfWeek'].disable();
      this.selectedRuleForm.controls['periodStart'].disable();
      this.selectedRuleForm.controls['periodEnd'].disable();
      this.selectedRuleForm.controls['date'].enable();
      // this.selectedRuleForm.reset();
    } else {
      this.selectedRuleForm.controls['dayOfWeek'].enable();
      this.selectedRuleForm.controls['periodStart'].enable();
      this.selectedRuleForm.controls['periodEnd'].enable();
      this.selectedRuleForm.controls['date'].disable();
    }
    this.selectedRule.date = this.getDate(this.selectedRule.date);
    this.periodStartChanged(this.selectedRule.periodStart);
  }

  addStrategy() {
    this.displayStrategy = true;
  }

  createNewStrategy() {
    this.http_addMessagingStrategy(this.newStrategy, (data: any) => {
      this.showSuccessMessage('Strategy has been created');
      this.messagingStrategies = data.payload;
    });
    this.displayStrategy = false;
  }

  deleteStrategy() {
    this.http_removeMessagingStrategy(this.selectedStrategy, (data: any) => {
      this.showSuccessMessage('Strategy has been deleted');
      this.messagingStrategies = data.payload;
    });
  }

  saveStrategy() {
    this.http_updateMessagingStrategy(this.selectedStrategy, (data: any) => {
      this.showSuccessMessage('Strategy has been updated');
      this.messagingStrategies = data.payload;
    });
  }

  addRule() {
    this.displayRule = true;
  }

  createNewRule() {
    this.newRule.strategyId = this.selectedStrategy.id;

    const conflictingRule = this.findConfiltingRule(this.newRule);
    if (!isUndefined(conflictingRule)) {
      this.showMessage(
        'error',
        'Conflicting Rule exists',
        'Rule with same day of week, device type, number of login ' +
          'and period from ' +
          conflictingRule.periodStart.description +
          ' to ' +
          conflictingRule.periodEnd.description,
      );
      return;
    }

    this.http_addMessagingStrategyRule(this.newRule, (data: any) => {
      this.showSuccessMessage('Rule has been created');
      this.loadRulesFromResponse(data);
    });
    this.displayRule = false;
  }

  deleteRule() {
    this.http_removeMessagingStrategyRule(
      { id: this.selectedRule.id },
      (data: any) => {
        this.showSuccessMessage('Rule has been deleted');
        this.loadRulesFromResponse(data);
      },
    );
  }

  saveRule() {
    if (this.selectedRule.useExactDate === false) {
      const coflictingRule = this.findConfiltingRule(this.selectedRule);
      if (!isUndefined(coflictingRule)) {
        this.showMessage(
          'error',
          'Conflicting Rule exists',
          'Rule with same day of week, device type, number of login ' +
            'and period from ' +
            coflictingRule.periodStart.description +
            ' to ' +
            coflictingRule.periodEnd.description,
        );
        return;
      }
    }

    if (this.selectedRule.useExactDate === null) {
      this.selectedRule.useExactDate = false;
    }

    this.http_updateMessagingStrategyRule(this.selectedRule, (data: any) => {
      this.showSuccessMessage('Rule has been updated');
      this.loadRulesFromResponse(data);
    });
  }

  periodStartChanged(e) {
    if (!isNullOrUndefined(this.selectedRule.periodStart)) {
      const periodStartId = isUndefined(e)
        ? this.selectedRule.periodStart.id
        : e.id;
      if (periodStartId === this.PERIOD_START_ANY) {
        this.selectedRule.periodEnd = this.periodsOfDay.filter(function(el) {
          if (!isNull(el.id)) {
            return el.id === periodStartId;
          }
        })[0];
        this.periodsOfDayEnd = [this.selectedRule.periodEnd];
      } else {
        this.periodsOfDayEnd = this.periodsOfDay.filter(function(el) {
          return el.id > periodStartId;
        });
      }
    }
  }

  periodStartNewChanged() {
    const periodStartId = this.newRule.periodStart.id;
    if (periodStartId === this.PERIOD_START_ANY) {
      this.newRule.periodEnd = this.periodsOfDay.filter(function(el) {
        return el.id === periodStartId;
      })[0];
      this.periodsOfDayEnd = [this.newRule.periodEnd];
    } else {
      this.periodsOfDayEnd = this.periodsOfDay.filter(function(el) {
        return el.id > periodStartId;
      });
    }
  }

  findConfiltingRule(rule: MessagingRule) {
    if (this.newRuleForm.controls['periodEnd'].enabled) {
      let conflictingRule: MessagingRule;
      this.messagingRules.forEach(function(el) {
        if (!isNull(el.dayOfWeek) && !isNull(rule.dayOfWeek)) {
          if (
            el.dayOfWeek.id === rule.dayOfWeek.id &&
            el.deviceType.id === rule.deviceType.id &&
            el.numberOfLogin === rule.numberOfLogin
          ) {
            if (
              (rule.periodStart.id <= el.periodStart.id &&
                rule.periodEnd.id > el.periodStart.id) ||
              (rule.periodStart.id < el.periodEnd.id &&
                rule.periodEnd.id >= el.periodEnd.id) ||
              (rule.periodStart.id >= el.periodStart.id &&
                rule.periodEnd.id <= el.periodEnd.id)
            ) {
              if (el.id !== rule.id) {
                conflictingRule = el;
                return;
              }
            }
          }
        }
      });
      return conflictingRule;
    }
    return;
  }

  unselectRow() {
    this.selectedStrategy = undefined;
  }

  unselectRuleRow() {
    this.selectedRule = undefined;
  }

  createEditor(e) {
    this.outputHTML = '<p>Type something here!</p>';
  }

  checkDate(e, form: FormGroup) {
    if (e) {
      console.log('E', e);
      form.controls['dayOfWeek'].disable();
      form.controls['periodStart'].disable();
      form.controls['periodEnd'].disable();
      form.controls['numberOfLogin'].enable();
      form.controls['date'].enable();
      if (form === this.newRuleForm) {
        form.reset();
      }
    } else {
      form.controls['dayOfWeek'].enable();
      form.controls['periodStart'].enable();
      form.controls['periodEnd'].enable();
      form.controls['numberOfLogin'].enable();
      form.controls['date'].disable();
      if (form === this.newRuleForm) {
        form.reset();
      }
    }
  }

  getDate(date) {
    if (date) {
      return new Date(date);
    }
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }

  private loadRulesFromResponse(data) {
    this.messagingRules = data.payload;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/captive-portal/messaging-strategies/messaging-strategies.component.ts